import { Component, Input, OnInit } from '@angular/core';
import { JobTaskService } from '../../services/job-task/job-task.service';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import { JobTaskStatus } from '../../enum/job-task-status.enum';
import { FileSizePipe } from '../../pipes/file-size/file-size.pipe';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-button-download-export',
  templateUrl: './button-download-export.component.html',
  styleUrls: ['./button-download-export.component.css'],
  providers: [FileSizePipe]
})
export class ButtonDownloadExportComponent implements OnInit {

  public showSpinner = false;
  public faCloudDownloadAlt = faCloudDownloadAlt;
  public completed = JobTaskStatus.STATUS_COMPLETED;
  public labelTooltip: string;

  @Input() object: any;

  constructor(private jobTaskService: JobTaskService,
              private fileSizePipe: FileSizePipe,
              private translateService: TranslateService,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.labelTooltip = this.translateService.instant('JOB_TASK_DOWNLOAD') + ' (' +
      this.fileSizePipe.transform(this.object.filesize) + ')';
  }

  download() {
    const token = this.authenticationService.getToken();
    const downloadPath = environment.apiUrl + environment.guardedRoute + 'auth/job-tasks/download/' + this.object.id + '?token=' + token;

    window.open(downloadPath);
  }

}
